/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const music = new Audio( $( '.hero-banner__bottle-cap-link' ).attr( 'data-sound' ) );
      music.volume = 0.3;

      $( '.hero-banner__bottle-cap-link' ).on( 'mouseenter', function() {
        music.play();
      } );
      // const textPath = document.querySelector( textPathSelector );
      // const text = document.querySelector( textSelector );
      $( '.hero-banner__bottle-cap-link' ).each( function( index, element ) {
        const textPath = $( element ).find( '.cap-badge__text-path' );
        const text = $( element ).find( '.cap-badge__text' );

        fitBottleCapText( textPath[0], text[0] );
      } );
      function fitBottleCapText( textPath, text ) {
        const path = document.querySelector( textPath.getAttribute( 'href' ) );

        if ( !textPath || !text || !path ) return;

        const textLength = text.getComputedTextLength();
        const pathLength = path.getTotalLength();

        if ( textLength > pathLength ) {
          text.classList.add( 'text-long' );
        } else {
          text.classList.remove( 'text-long' );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
